// web/src/utils/venueLabels.js
// Per-venue-type wording/behavior for order actions. Keyed by the JWT's
// `type` claim (restaurant|bar|hotel|cafe|club|lounge|canteen|fast_food|other).
export const VENUE_LABELS = {
  restaurant: { sendLabel: '🔥 SEND TO KITCHEN', showSend: true },
  cafe:       { sendLabel: '🔥 SEND TO KITCHEN', showSend: true },
  canteen:    { sendLabel: '🔥 SEND TO KITCHEN', showSend: true },
  fast_food:  { sendLabel: '🔥 SEND TO KITCHEN', showSend: true },
  bar:        { sendLabel: null, showSend: false },
  club:       { sendLabel: null, showSend: false },
  lounge:     { sendLabel: null, showSend: false },
  hotel:      { sendLabel: '🔥 SEND TO KITCHEN', showSend: true },
  other:      { sendLabel: '🔥 SEND TO KITCHEN', showSend: true },
};
